import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const tradeHistorySchema = z.object({
  /** 約定ID */
  trade_id: z.number(),
  /** 通貨ペア */
  pair: z.string(),
  /** 注文ID */
  order_id: z.number(),
  /** buy または sell */
  side: z.union([z.literal('buy'), z.literal('sell')]),
  /** long または short（信用取引の時のみ） */
  position_side: z.union([z.literal('long'), z.literal('short')]).optional(),
  /** limit、market、stop、stop_limit、take_profit、stop_loss, losscut のいずれか */
  type: z.union([
    z.literal('limit'),
    z.literal('market'),
    z.literal('stop'),
    z.literal('stop_limit'),
    z.literal('take_profit'),
    z.literal('stop_loss'),
    z.literal('losscut'),
  ]),
  /** 注文量 */
  amount: decimalSchema,
  /** 約定価格 */
  price: decimalSchema,
  /** maker または taker */
  maker_taker: z.union([z.literal('maker'), z.literal('taker')]),
  /** base手数料 */
  fee_amount_base: decimalSchema,
  /** quote手数料 */
  fee_amount_quote: decimalSchema,
  /** quote発生手数料。後ほど徴収される。現物取引では fee_amount_quote と同値。 */
  fee_occurred_amount_quote: decimalSchema,
  /** 実現損益 */
  profit_loss: decimalSchema.optional(),
  /** 利息 */
  interest: decimalSchema.optional(),
  /** 約定日時（UnixTimeのミリ秒） */
  executed_at: z.number().int(),
})

export const responseSchema = z.object({
  data: z.object({
    trades: z.array(tradeHistorySchema),
  }),
})
